import * as React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import * as ExcludedRecommendation from '../../config/excludedRecommendation/ExcludedRecommendation';
import './AirlineCompanyLogo.css';

const propTypes = {
  flights: PropTypes.any
};

class AirlineCompanyLogo extends React.Component {
  TUDO_AZUL_COMPANY_ID = 'AD';
  companyId;

  constructor(props) {
    super(props);
    this.computeCompanyLogoId();
  }

  computeCompanyLogoId() {
    const flightPartner = this.props.flights
      .filter(flight => {
        if (ExcludedRecommendation.excludedRecommendation) {
          return (
            flight.marketingCarrier !==
              ExcludedRecommendation.excludedRecommendation.marketingCarrier &&
            flight.marketingCarrier !== this.TUDO_AZUL_COMPANY_ID
          );
        } else {
          return flight.marketingCarrier !== this.TUDO_AZUL_COMPANY_ID;
        }
      })
      .pop();

    this.companyId =
      flightPartner && flightPartner.marketingCarrier
        ? flightPartner.marketingCarrier
        : this.TUDO_AZUL_COMPANY_ID;
  }

  render() {
    return (
      <div data-test="airlineCompanyLogo" className={`airlineCompanyLogo`}>
        <Row>
          <Col>
            <div data-test={`logo-${this.companyId}`} className={`icon-${this.companyId}`} />
          </Col>
        </Row>
      </div>
    );
  }
}

AirlineCompanyLogo.propTypes = propTypes;

export default AirlineCompanyLogo;



// WEBPACK FOOTER //
// ./src/components/airlineCompanyLogo/AirlineCompanyLogo.jsx